import cn from 'clsx'

import React, { useCallback, useContext, useState } from 'react'
import type { Rect } from 'types/screen'
import type { PopoverItemType } from 'types/ui'
import { ThemeContext } from 'contexts/theme'
import { PopoverItem } from './PopoverItem'
import type { CSSProperties } from 'react'
const getRectForNode = (node: HTMLElement): Rect => {
  const rect = node.getBoundingClientRect()
  return {
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height,
  }
}

const getViewport = () => ({
  width: document.body?.clientWidth ?? 0,
  height: window.innerHeight,
})

type Props = {
  compact?: boolean
  items: PopoverItemType[]
  onClick: (arg0: PopoverItemType) => void
}
export const NestedPopover = ({
  compact,
  items,
  onClick,
}: Props): React.ReactElement<'div'> => {
  const theme = useContext(ThemeContext).theme
  const [style, setStyle] = useState<CSSProperties>({})
  const setRef = useCallback((node: HTMLDivElement | null | undefined) => {
    if (node) {
      const rect = getRectForNode(node)
      const viewport = getViewport()

      if (rect.left + rect.width > viewport.width) {
        setStyle({
          left: 'initial',
          right: '100%',
        })
      }
    }
  }, [])
  return (
    <div
      className={cn('popover-item-nested', {
        'popover--theme-dark': theme === 'dark',
      })}
      style={style}
    >
      <div ref={setRef}>
        {items.map((item: PopoverItemType, index: number) => {
          if (!item) return
          return (
            <PopoverItem
              compact={compact}
              item={item}
              key={item.value || index}
              onClick={onClick}
            />
          )
        })}
      </div>
    </div>
  )
}
